import { Component, OnInit, AfterViewInit } from '@angular/core';
declare var AOS: any;
@Component({ selector: 'app-hw-tcu', templateUrl: './tcu.component.html', styleUrls: ['./tcu.component.scss'], standalone: false })
export class TCUComponent implements OnInit, AfterViewInit {
  activeSection = 'overview';
  sections = [
    { id: 'overview', label: 'Overview', icon: 'bx-layer' },
    { id: 'specs', label: 'Specs', icon: 'bx-chip' },
    { id: 'buy', label: 'Buy Now', icon: 'bx-cart' },
  ];
  specs = [
    { label: 'Interface', value: 'CAN Bus + OBD-II' },
    { label: 'Connectivity', value: '4G LTE Cat-4 + Wi-Fi + BT5' },
    { label: 'GNSS', value: 'GPS + GLONASS + BeiDou' },
    { label: 'I/O', value: '4 Digital IN / 2 Digital OUT' },
    { label: 'Power', value: '9–36V DC with backup battery' },
    { label: 'Mounting', value: 'Hardwired, DIN rail or surface' },
  ];
  ngOnInit() {}
  ngAfterViewInit() { try { AOS.refresh(); } catch (e) {} }
  scrollTo(id: string) {
    this.activeSection = id;
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
